import Label from './Label'
import Row from './IndentedRow'
import RecipientsEditor from './RecipientsEditor'

const BccRow = ({ className, ...rest }) => {
  const { ticketId } = rest
  return (
    <Row className={className} flex="1 0 100%" ml={3}>
      <Label>BCC:</Label>
      <RecipientsEditor
        key={`recipientseditor-bcc-${ticketId}`}
        ml={1}
        type="bcc"
        {...rest}
      />
    </Row>
  )
}

export default BccRow
